import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { CheckIcon, XIcon, ArrowRightIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function OfferSection() {
  const {
    isExpired
  } = useCountdown();
  return <div className="grain-section w-full px-6 py-32 md:py-40 bg-page-bg" data-id="element-211">
      <div className="max-w-6xl mx-auto space-y-32" data-id="element-212">
        {/* Chapter 6 */}
        <div className="space-y-16" data-id="element-213">
          <div className="flex flex-col md:flex-row md:items-center gap-8 mb-8" data-id="element-214">
            <div className="text-8xl md:text-9xl font-black text-black/5 font-sans tracking-tighter" data-id="element-215">
              06
            </div>
            <div className="h-px w-24 bg-black/10 hidden md:block" data-id="element-216"></div>
            <div data-id="element-217">
              <p className="text-xs text-teal-600 font-bold tracking-widest uppercase mb-3" data-id="element-218">
                Chapter Six
              </p>
              <h2 className="text-4xl md:text-6xl font-bold text-ink tracking-tight" data-id="element-219">
                Who This Is For <br data-id="element-220" />
                <span className="text-teal-600" data-id="element-221">(And Who It's NOT For)</span>
              </h2>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-12" data-id="element-222">
            <div className="bg-white rounded-[2.5rem] p-10 shadow-md border border-teal-100" data-id="element-223">
              <h3 className="text-2xl font-bold text-teal-700 mb-8 flex items-center gap-3" data-id="element-224">
                <CheckIcon className="w-8 h-8" data-id="element-225" /> This Advanced session is for
                you if:
              </h3>
              <ul className="space-y-4 text-lg text-ink-light" data-id="element-226">
                <li className="flex gap-3" data-id="element-227">
                  <span className="text-teal-500 font-bold" data-id="element-228">→</span> You've been
                  stuck despite trying multiple approaches
                </li>
                <li className="flex gap-3" data-id="element-229">
                  <span className="text-teal-500 font-bold" data-id="element-230">→</span> You've seen
                  specialists who couldn't figure out what's wrong
                </li>
                <li className="flex gap-3" data-id="element-231">
                  <span className="text-teal-500 font-bold" data-id="element-232">→</span> You're
                  dealing with something "complex" or "treatment-resistant"
                </li>
                <li className="flex gap-3" data-id="element-233">
                  <span className="text-teal-500 font-bold" data-id="element-234">→</span> You want
                  PRECISION instead of guesswork
                </li>
                <li className="flex gap-3" data-id="element-235">
                  <span className="text-teal-500 font-bold" data-id="element-236">→</span> You're
                  ready to finally understand what's REALLY going on
                </li>
                <li className="flex gap-3" data-id="element-237">
                  <span className="text-teal-500 font-bold" data-id="element-238">→</span> You're
                  willing to follow through on what you learn
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-[2.5rem] p-10 shadow-md border border-red-100" data-id="element-239">
              <h3 className="text-2xl font-bold text-red-700 mb-8 flex items-center gap-3" data-id="element-240">
                <XIcon className="w-8 h-8" data-id="element-241" /> This is NOT for you if:
              </h3>
              <ul className="space-y-4 text-lg text-ink-light" data-id="element-242">
                <li className="flex gap-3" data-id="element-243">
                  <span className="text-red-500 font-bold" data-id="element-244">→</span> You're just
                  looking for a magic pill
                </li>
                <li className="flex gap-3" data-id="element-245">
                  <span className="text-red-500 font-bold" data-id="element-246">→</span> You're not
                  willing to actually implement
                </li>
                <li className="flex gap-3" data-id="element-247">
                  <span className="text-red-500 font-bold" data-id="element-248">→</span> You expect
                  overnight results without doing the work
                </li>
                <li className="flex gap-3" data-id="element-249">
                  <span className="text-red-500 font-bold" data-id="element-250">→</span> You're not
                  ready to invest in yourself
                </li>
              </ul>
            </div>
          </div>

          <div className="text-center text-xl font-medium text-ink max-w-2xl mx-auto" data-id="element-251">
            <p data-id="element-252">
              Be honest with yourself about where you're at. Because we're only
              taking a limited number of people. And we'd rather those slots go
              to people who are ready.
            </p>
          </div>
        </div>

        {/* Time's Running Out */}
        <div className="bg-gradient-to-br from-[#1a1a2e] to-[#0f172a] text-white rounded-[3rem] p-8 md:p-20 text-center shadow-2xl space-y-10" data-id="element-253">
          <h3 className="text-4xl md:text-6xl font-bold tracking-tight" data-id="element-254">
            {isExpired ? 'Offer Has Ended' : "Time's Running Out"}
          </h3>
          <div className="space-y-6 text-xl md:text-2xl text-white/80 font-light max-w-3xl mx-auto" data-id="element-255">
            {isExpired ? <>
                <p data-id="element-256">
                  The introductory $1,500 offer has ended. The Advanced session
                  is now available at its standard rate of $5,000.
                </p>
                <p data-id="element-257">
                  We're also capping this at 20 total slots. And we're NOT
                  making exceptions.
                </p>
              </> : <>
                <p data-id="element-258">
                  We're only running this offer for a VERY limited time. After
                  that, the Advanced session goes back to $5,000.
                </p>

                <p className="font-bold text-white" data-id="element-259">
                  Don't be the person who sits on this... Misses the deadline...
                  Then emails us in 3 months asking if we can "make an
                  exception." (We can't. And we won't.)
                </p>
              </>}
          </div>
          <a href="https://go.peptidescienceinstitute.com/meeting-with-the-master-advanced" className="block sm:inline-block w-full sm:w-auto px-12 py-6 bg-teal-600 hover:bg-teal-700 text-white text-lg sm:text-xl font-bold rounded-full transition-all shadow-lg hover:shadow-xl hover:-translate-y-1 text-center" data-id="element-260">
            Book Your Meeting Now
          </a>
        </div>

        {/* PSI PRO Members */}
        <div className="bg-white rounded-[2.5rem] p-12 md:p-16 border border-teal-100 text-center space-y-8 shadow-sm" data-id="element-261">
          <h3 className="text-3xl md:text-4xl font-bold text-ink tracking-tight" data-id="element-262">
            PSI PRO Members – Join Us for the LIVE Q&A
          </h3>
          <p className="text-xl text-ink-light font-light max-w-3xl mx-auto" data-id="element-263">
            If you're a member of our Private Research Order, join us for our
            LIVE Q&A with Brenden & Dr. Ali on Feb 21 at 12pm EST. They'll be
            answering questions... Breaking down the science... And you'll get
            to see firsthand how they think.
          </p>
        </div>

        {/* Next Steps */}
        <div className="space-y-12 text-center" data-id="element-264">
          <h3 className="text-4xl font-bold text-ink tracking-tight" data-id="element-265">
            Your Next Steps
          </h3>
          <div className="grid gap-6 max-w-2xl mx-auto text-left" data-id="element-266">
            {['Click the button below to book your Meeting With the Master: ADVANCED session', "Submit your form (we'll send instructions)", 'Your assigned master reviews your case', 'You show up for your meeting ready to go', 'You receive your written Precision Cell Blueprint', "You implement the program (and we'll provide basic program support)"].map((step, i) => <div key={i} className="flex items-center gap-4 bg-white p-6 rounded-2xl shadow-sm border border-black/5 hover:shadow-md transition-shadow" data-id="element-267">
                <div className="w-8 h-8 rounded-full bg-teal-100 text-teal-700 flex items-center justify-center font-bold flex-shrink-0" data-id="element-268">
                  {i + 1}
                </div>
                <p className="text-lg font-medium text-ink" data-id="element-269">{step}</p>
              </div>)}
          </div>
          <a href="https://go.peptidescienceinstitute.com/meeting-with-the-master-advanced" className="inline-flex items-center justify-center gap-3 w-full sm:w-auto px-8 sm:px-12 py-6 bg-gradient-to-r from-[#1d1d1f] to-[#2d2d2f] hover:from-black hover:to-[#1a1a1c] text-white text-lg sm:text-2xl font-bold rounded-full transition-all shadow-lg hover:shadow-xl hover:-translate-y-1" data-id="element-270">
            Book Your Meeting Now – Final Call
            <ArrowRightIcon className="w-6 h-6" data-id="element-271" />
          </a>
        </div>

        {/* P.S. */}
        <div className="max-w-3xl mx-auto space-y-8 text-lg text-ink-light font-light bg-white p-10 rounded-3xl border border-black/5 shadow-sm" data-id="element-272">
          <p data-id="element-273">
            <span className="font-bold text-ink" data-id="element-274">P.S.</span> If you're wondering
            whether this is "worth it"... Consider this: How much have you
            already spent chasing answers? Specialists, treatments, supplements,
            tests... Most people have dropped thousands by now. With little to
            show for it.
          </p>
          <p data-id="element-275">
            {isExpired ? <>
                This session is{' '}
                <span className="font-bold text-ink" data-id="element-276">$5,000</span>. And you're
                getting direct access to people who've solved cases that stumped
                entire medical teams. Plus a complete written roadmap. Plus
                implementation support. Plus a $1,500 credit if you continue.
                The ROI is obvious.
              </> : <>
                This session is $1,500. And you're getting direct access to
                people who've solved cases that stumped entire medical teams.
                Plus a complete written roadmap. Plus implementation support.
                Plus a $1,500 credit if you continue. The ROI is obvious.
              </>}
          </p>
        </div>
      </div>
    </div>;
}